import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';

const VesselTypeSummaryCard = ({ className, volume, quantity }) => {
  return (
    <Card className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Summary</h3>
      <h4 className="table-header mv0">Volume</h4>
      <p>{volume} L</p>
      <h4 className="table-header mv0">Quantity</h4>
      <p>{quantity}</p>
    </Card>
  );
};

export default VesselTypeSummaryCard;



// WEBPACK FOOTER //
// ./src/components/vesselTypeSummaryCard/vesselTypeSummaryCard.jsx